import { z } from 'zod';
import { objectIdSchema } from './common.js';
const dashboardPeriodSchema = z.enum(['today', '7d', '30d']);
export const dashboardStatsQuerySchema = z.object({
    period: dashboardPeriodSchema.default('today'),
});
export const deliveryListQuerySchema = z.object({
    page: z.coerce.number().int().min(1).default(1),
    limit: z.coerce.number().int().min(1).max(100).default(20),
    status: z.enum(['pending', 'sent', 'failed', 'cancelled']).optional(),
    chatId: objectIdSchema.optional(),
    reminderId: objectIdSchema.optional(),
    from: z.coerce.date().optional(),
    to: z.coerce.date().optional(),
});
export const deliveryMessageParamsSchema = z.object({
    id: objectIdSchema,
});
export const updateDeliveryMessageSchema = z.object({
    text: z
        .string()
        .min(1)
        .max(4096)
        .refine((text) => text.trim().length > 0, {
        message: 'Введите текст сообщения',
    }),
});
//# sourceMappingURL=dashboard.js.map